import React from 'react';

import cl from './Contacts.module.css'

import contactImg from '../../../assets/images/main_contact_img.png'
import Footer from '../../../components/Footer/Footer';
import ContactForm from '../../../components/ContactForm/ContactForm';
import {Helmet} from "react-helmet-async";
import tgIcon from '../../../assets/icons/tgIcon.svg'
import whatsAppIcon from '../../../assets/icons/whatsAppForContact.svg'
import linkedIcon from '../../../assets/icons/linkedinIcon.svg'

const Contacts = () => {
    return (
        <div className='contacts_page'>
            <Helmet>
                <title>Contact Fortres | Digital Banking Support</title>
                <meta name="description"
                      content="Get in touch with Fortres for support, partnerships, or inquiries about digital banking and financial services."/>
                <meta name="keywords"
                      content="contact banking support,  fintech support team, payment platform support"/>
            </Helmet>
            <div className={cl.contact_main_container}>
                <div className={cl.left_side_contact}>
                    <h1 className={cl.title_contact}>
                        We’re Here to Help
                    </h1>
                    <p className={cl.contact_description}>
                        Have questions or need assistance? Reach out via phone, email, or live chat. Our dedicated
                        support team is ready to assist you.
                    </p>
                    <h3 className={cl.subtitle_contact}>
                        Contact Details:
                    </h3>
                    <div className={cl.contact_info_row}>
                        <span className={cl.contact_info_item}>
                            Email: info@fortres.tech
                        </span>
                        <span className={cl.contact_info_item}>
                            Phone: +420775497164
                        </span>

                        <span className={cl.contact_info_item}>
                            Office Address: Olštýnská 607/1, Troja (Praha 8), 181 00 Praha<br/>
                            P.O. Box 149, PC 325, Sultanate of Oman
                        </span>

                        <span className={cl.contact_info_item}>
                            Reach us:
                            <a href="https://t.me/+420775497164">
                                <img src={tgIcon} alt="Telegram"/>
                            </a>
                            <a href="https://wa.me/447846774768">
                                <img src={whatsAppIcon} alt=""/>
                            </a>
                            <a href="https://www.linkedin.com/company/fortres-bancorp/">
                                <img src={linkedIcon} alt=""/>
                            </a>

                        </span>
                    </div>
                </div>
                <div className={cl.right_side_contact}>
                    <img src={contactImg} alt="#contact_img"/>
                </div>
            </div>
            <ContactForm/>

        </div>
    );
};

export default Contacts;